(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["reg-project-workspace"] && !Shopify.designMode) return;
  try {
    (() => {
  const root = document.querySelector('[data-reg-project]');
  if (!root || window.REGProject) return;
  const text = JSON.parse(root.querySelector('[data-reg-labels]').dataset.json);
  const dialog = root.querySelector('dialog');
  const form = root.querySelector('form');
  const list = root.querySelector('[data-reg-lines]');
  const status = root.querySelector('[data-reg-status]');
  const key = 'reg-project-v1';
  const pendingKey = 'reg-project-pending-v1';
  const maxLines = 40;
  const maxQuantity = 999;
  let lines = [];
  let opener;
  let persistent = true;
  const safeText = (value, limit = 350) => String(value ?? '').replace(/[\u0000-\u001f]/g, ' ').slice(0, limit);
  const quantity = value => Math.max(1, Math.min(maxQuantity, Math.floor(Number(value) || 1)));
  const productPath = (value, id) => {
    try {
      const url = new URL(value, location.origin);
      if (url.origin !== location.origin || !/\/products\/[^/]+\/?$/.test(url.pathname)) return '';
      url.search = '';
      url.hash = '';
      url.searchParams.set('variant', id);
      return url.pathname + url.search;
    } catch { return ''; }
  };
  const clean = item => {
    if (!item || !/^\d{1,18}$/.test(String(item.id))) return null;
    const id = String(item.id);
    const url = productPath(item.url, id);
    if (!url || !safeText(item.title)) return null;
    const lineKey = /^[a-zA-Z0-9:-]{1,100}$/.test(String(item.key || '')) ? String(item.key) : id;
    return { id, key: lineKey, url, title: safeText(item.title), sku: safeText(item.sku, 120), options: safeText(item.options, 1000), quantity: quantity(item.quantity) };
  };
  const decode = value => {
    try {
      const data = JSON.parse(value);
      if (!Array.isArray(data?.lines) || Date.now() - data.updated > 30 * 86400000) return [];
      const result = [];
      data.lines.slice(0, maxLines).forEach(item => {
        const next = clean(item);
        if (next && !result.some(x => x.key === next.key)) result.push(next);
      });
      return result;
    } catch { return []; }
  };
  try { lines = decode(localStorage.getItem(key)); } catch { persistent = false; }
  const announce = message => { status.textContent = message; };
  const save = () => {
    try { localStorage.setItem(key, JSON.stringify({ updated: Date.now(), lines })); }
    catch { persistent = false; }
    root.querySelector('[data-reg-storage]').hidden = persistent;
  };
  const buildSummary = () => lines.map((item, i) => [
    `${i + 1}. ${item.title}`,
    `${text.sku}: ${item.sku || text.notSpecified}`,
    `${text.selection}: ${item.options || text.standard}`,
    `${text.quantity}: ${item.quantity}`,
    `${location.origin}${item.url}`
  ].join('\n')).join('\n\n');
  const element = (tag, className, content) => {
    const el = document.createElement(tag);
    if (className) el.className = className;
    if (content !== undefined) el.textContent = content;
    return el;
  };
  const updateCounts = () => {
    document.querySelectorAll('[data-reg-count]').forEach(node => { node.textContent = String(lines.length); });
    root.querySelector('[data-reg-empty]').hidden = lines.length > 0;
    root.querySelector('[data-reg-clear]').hidden = lines.length === 0;
    root.querySelector('[data-reg-download]').hidden = lines.length === 0;
    root.querySelector('[data-reg-summary]').value = buildSummary();
    form.querySelector('[name="contact[body]"]').required = lines.length === 0;
  };
  const render = () => {
    list.replaceChildren();
    lines.forEach(item => {
      const row = element('li', 'reg-project-line');
      row.dataset.id = item.key;
      const info = element('div', 'reg-project-line__info');
      const link = element('a', 'reg-project-line__title', item.title);
      link.href = item.url;
      info.append(link, element('p', '', item.options || text.standard), element('p', 'reg-project-small', `${text.sku}: ${item.sku || text.notSpecified}`));
      const controls = element('div', 'reg-project-line__controls');
      const label = element('label', '', text.quantity);
      const input = element('input');
      input.type = 'number'; input.min = '1'; input.max = String(maxQuantity); input.step = '1'; input.value = item.quantity;
      input.dataset.regQuantity = item.key;
      input.setAttribute('aria-label', `${text.quantity}: ${item.title}`);
      label.append(input);
      const remove = element('button', 'reg-project-link', text.remove);
      remove.type = 'button'; remove.dataset.regRemove = item.key;
      remove.setAttribute('aria-label', `${text.remove}: ${item.title}`);
      controls.append(label, remove);
      row.append(info, controls); list.append(row);
    });
    updateCounts();
  };
  const open = async trigger => {
    opener = trigger || document.activeElement;
    const drawer = trigger?.closest('.modal[open]');
    if (drawer && typeof drawer.hide === 'function') {
      const returnFocus = drawer.activeElement || document.querySelector('.cart-drawer-button') || document.querySelector('[data-reg-open]');
      await drawer.hide();
      await new Promise(resolve => setTimeout(resolve, 0));
      opener = returnFocus;
    }
    render();
    if (!dialog.open) dialog.showModal();
    document.documentElement.classList.add('reg-project-open');
    if (trigger?.dataset.regService) form.querySelector('[data-reg-service]').value = trigger.dataset.regService;
    const planner = trigger?.closest('[data-reg-planner]');
    if (planner) {
      const postcode = planner.querySelector('[data-reg-postcode]');
      const service = planner.querySelector('[data-reg-plan-service]');
      if (postcode) form.querySelector('[data-reg-quote-postcode]').value = postcode.value;
      if (service) form.querySelector('[data-reg-service]').value = service.value;
    }
    root.querySelector('[data-reg-close]').focus();
  };
  const add = (item, mode = 'add') => {
    const next = clean(item);
    if (!next) return false;
    const existing = lines.find(x => x.key === next.key);
    if (existing) Object.assign(existing, next, { quantity: mode === 'max' ? Math.max(existing.quantity, next.quantity) : quantity(existing.quantity + next.quantity) });
    else if (lines.length < maxLines) lines.push(next);
    else return false;
    return true;
  };
  const addProduct = button => {
    const panel = button.closest('[data-reg-product]');
    const info = panel?.closest('product-info');
    if (!panel || button.disabled || info?.hasAttribute('data-reg-variant-pending')) return;
    try {
      const item = JSON.parse(panel.querySelector('[data-reg-product-json]').dataset.json);
      const input = info?.querySelector('input[name="quantity"]');
      item.quantity = quantity(input?.value || 1);
      const added = add(item);
      save(); open(button); announce(added ? text.added : text.limit);
    } catch { open(button); announce(text.selectionError); }
  };
  const importCart = async button => {
    if (button.disabled) return;
    button.disabled = true;
    try {
      const response = await fetch(root.dataset.cartUrl, { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
      if (!response.ok) throw new Error('cart');
      const cart = await response.json();
      if (!Array.isArray(cart.items)) throw new Error('cart');
      let overflow = false;
      const grouped = new Map();
      cart.items.forEach(item => {
        const id = String(item.variant_id);
        const propertiesEntries = Object.entries(item.properties || {}).filter(([name]) => !name.startsWith('_'));
        const groupKey = propertiesEntries.length || item.selling_plan_allocation ? String(item.key || id) : id;
        const previous = grouped.get(groupKey);
        const configuration = (item.options_with_values || []).filter(x => x.value !== 'Default Title').map(x => `${x.name}: ${x.value}`).join(' / ');
        const properties = propertiesEntries.map(([name, value]) => `${name}: ${safeText(value, 300)}`).join(' / ');
        const plan = item.selling_plan_allocation?.selling_plan?.name;
        const details = [configuration, properties, plan].filter(Boolean).join(' / ');
        grouped.set(groupKey, { id, key: groupKey, url: item.url, title: item.product_title, sku: item.sku, quantity: quantity((previous?.quantity || 0) + item.quantity), options: details });
      });
      grouped.forEach(item => { if (!add(item, 'max')) overflow = true; });
      save(); open(button); announce(overflow ? text.limit : cart.items.length ? text.cartImported : text.cartEmpty);
    } catch { open(button); announce(text.cartError); }
    finally { button.disabled = false; }
  };
  document.addEventListener('click', event => {
    const target = event.target.closest('[data-reg-open], [data-reg-add], [data-reg-import]');
    if (!target) return;
    event.preventDefault();
    if (target.hasAttribute('data-reg-add')) addProduct(target);
    else if (target.hasAttribute('data-reg-import')) importCart(target);
    else open(target);
  });
  root.addEventListener('click', event => {
    const button = event.target.closest('button');
    if (!button) return;
    if (button.hasAttribute('data-reg-close')) dialog.close();
    if (button.dataset.regRemove) {
      const index = lines.findIndex(x => x.key === button.dataset.regRemove);
      lines = lines.filter(x => x.key !== button.dataset.regRemove);
      save(); render(); announce(text.removed);
      (list.children[Math.min(index, list.children.length - 1)]?.querySelector('button') || root.querySelector('[data-reg-close]')).focus();
    }
    if (button.hasAttribute('data-reg-clear') && window.confirm(text.clearConfirm)) { lines = []; save(); render(); announce(text.cleared); root.querySelector('[data-reg-close]').focus(); }
    if (button.hasAttribute('data-reg-download')) {
      const blob = new Blob([`${text.heading}\n\n${buildSummary()}\n\n${text.quoteNote}`], { type: 'text/plain;charset=utf-8' });
      const url = URL.createObjectURL(blob);
      const anchor = element('a'); anchor.href = url; anchor.download = 'REG-Furniture-Project.txt'; document.body.append(anchor); anchor.click(); anchor.remove();
      setTimeout(() => URL.revokeObjectURL(url), 1000);
    }
  });
  root.addEventListener('change', event => {
    if (!event.target.matches('[data-reg-quantity]')) return;
    const item = lines.find(x => x.key === event.target.dataset.regQuantity);
    if (item) { item.quantity = quantity(event.target.value); event.target.value = item.quantity; save(); updateCounts(); }
  });
  dialog.addEventListener('close', () => {
    document.documentElement.classList.remove('reg-project-open');
    if (opener?.isConnected) opener.focus();
  });
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
  form.addEventListener('submit', event => {
    updateCounts();
    if (!form.reportValidity()) { event.preventDefault(); return; }
    const reference = `REG-${Date.now().toString(36).toUpperCase()}-${Math.random().toString(36).slice(2, 6).toUpperCase()}`;
    form.querySelector('[data-reg-reference]').value = reference;
    try { sessionStorage.setItem(pendingKey, JSON.stringify({ reference, submitted: Date.now() })); } catch {}
  });
  window.addEventListener('storage', event => {
    if (event.key === key) { lines = decode(event.newValue); render(); announce(text.updated); }
  });
  document.addEventListener('shopify:section:load', updateCounts);
  render();
  root.querySelector('[data-reg-storage]').hidden = persistent;
  let pending;
  try { pending = JSON.parse(sessionStorage.getItem(pendingKey)); } catch {}
  if (pending && Date.now() - pending.submitted < 2 * 3600000 && (root.querySelector('[data-reg-success]') || root.querySelector('[data-reg-errors]'))) {
    open();
    if (root.querySelector('[data-reg-success]')) {
      root.querySelector('[data-reg-success-reference]').textContent = pending.reference;
      try { sessionStorage.removeItem(pendingKey); } catch {}
    }
  }
  window.REGProject = { open: () => open(), getItems: () => structuredClone(lines) };
})();
  } catch(e) { console.error(e); }
})();

})();
